import React from 'react';
import PropTypes from 'prop-types';
import { Ratings, ReviewCount } from './styles/ReviewRatings.style';
import ProductRating from '../../ProductDetail/molecules/ProductRating/ProductRating';

const ReviewAndratingsHlp = ({ isTileRedesignAB, ratings, reviewCount }) => {
  if (isTileRedesignAB) {
    return ratings > 0 ? (
      <ProductRating
        ratings={ratings || 0}
        reviews={reviewCount}
        isTileRedesignAB={isTileRedesignAB}
      />
    ) : null;
  }

  return (
    <div>
      {ratings > 0 ? (
        <>
          <Ratings
            aria-label={`rating of this product is ${ratings} out of 5`}
            title={`Product Rating ${ratings}`}
            value={ratings}
          />
          <ReviewCount>{` (${reviewCount})`}</ReviewCount>
        </>
      ) : null}
    </div>
  );
};
ReviewAndratingsHlp.propTypes = {
  ratings: PropTypes.number,
  reviewCount: PropTypes.number,
};
ReviewAndratingsHlp.defaultProps = {
  ratings: 0,
  reviewCount: 0,
};
export default ReviewAndratingsHlp;
